import { TweenMax, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Scene, OrthographicCamera, WebGLRenderer, AmbientLight, PointLight, CubeTextureLoader, CubeTexture } from 'three';
import { WEBGL } from 'three/examples/jsm/WebGL.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export class SnowflakeIntro {
  private _scrollIndicator: TweenMax;
  // private _logo: TweenMax;
  // private _logoLetters: TweenMax;
  private _text1: TweenMax;
  private _text2: TweenMax;
  private _text3: TweenMax;
  private _shield: TweenMax;
  private _footer: TweenMax;
  private _timeline: TimelineMax = new TimelineMax().pause();

  private _scene: Scene = new Scene();
  private _renderer: WebGLRenderer = new WebGLRenderer({ antialias: true, alpha: true });
  private _camera: OrthographicCamera = new OrthographicCamera( - 100, 100, 100, -100, 1, 1000 );
  private _ambientLight: AmbientLight = new AmbientLight( 0xffffff, 3 );
  private _pointLight1: PointLight = new PointLight( 0xffffff, 1, 400 );
  private _pointLight2: PointLight = new PointLight( 0xffffff, 2, 400 );
  private _pointLight3: PointLight = new PointLight( 0xffffff, 3, 400 );
  private _objLoader: GLTFLoader = new GLTFLoader();
  private _texLoader: CubeTextureLoader = new CubeTextureLoader();
  private _textureCube: CubeTexture;
  private _run3D = true;

  init ( ): void {
    this._scrollIndicator = TweenMax.to('.intro-content .scroll-indicator', { y: 60, opacity: 0 });

    // this._logo = TweenMax.from('.intro-content .logo-container', { y: -120, x: -30, rotateX: 30, duration: 2.5 });
    // this._logoLetters = TweenMax.from('.intro-content .logo-letter', { x: -20, opacity: 0, duration: 0.4, stagger: { from: 'end', amount: 0.2 } });
    this._text1 = TweenMax.fromTo('.intro-content .gsap-text-1', { opacity:0, y: -30 }, { opacity: 1, y: 0, duration: 1 });
    this._text2 = TweenMax.fromTo('.intro-content .gsap-text-2', { opacity:0, y: -30 }, { opacity: 1, y: 0, duration: 1 });
    this._text3 = TweenMax.fromTo('.intro-content .gsap-text-3', { opacity:0, y: -30 }, { opacity: 1, y: 0, duration: 1 });
    this._footer = TweenMax.fromTo('.intro-content footer', { opacity:0 }, { opacity: 1, duration: 1 });

    // this._timeline.add( this._logo );
    // this._timeline.add( this._logoLetters, 2 );
    this._timeline.add( this._text1 );
    this._timeline.add( this._text2, 0.5 );
    this._timeline.add( this._text3, 1 );
    this._timeline.add( this._footer, 2 );

    if ( WEBGL.isWebGLAvailable() ) {
      this._shield = TweenMax.from('#shield-canvas-container', { opacity: 0, y: -90, duration: 2 });
      this._timeline.add( this._shield, 1.5 );

      this._textureCube = this._texLoader.load( ['./highway-cube.jpg', './highway-cube.jpg', './highway-cube.jpg', './highway-cube.jpg', './highway-cube.jpg', './highway-cube.jpg'] );
      this._scene.environment = this._textureCube; 
      this._scene.add( this._ambientLight );
  
      this._pointLight1.position.set( -100, -200, 200 );
      this._pointLight2.position.set( -100, 200, 200 );
      this._pointLight3.position.set( 200, 200, -200 );
      this._scene.add( this._pointLight1 );
      this._scene.add( this._pointLight2 );
      this._scene.add( this._pointLight3 );
  
      this._camera.position.set( 100, 40, 100 );
      this._camera.lookAt( this._scene.position );
  
      this._renderer.setSize( 520, 520 );
      document.getElementById('shield-canvas-container').appendChild( this._renderer.domElement );
  
      this._objLoader.load('./shield.glb', ( gltf: any ) => {
        this._scene.add( gltf.scene );
        gltf.scene.rotation.y = -2.4;
  
        const animate = () => {
          setTimeout(() => {
            requestAnimationFrame( animate );
            if ( this._run3D ) {
    
              gltf.scene.rotation.y += 0.01;
      
              this._renderer.render( this._scene, this._camera );
            }
          }, 16);
        };

        this._renderer.render( this._scene, this._camera );
        this._timeline.play();
        animate();
      });

      ScrollTrigger.create({
        trigger:'.intro-wrapper',
        start:'top top',
        end: 'bottom top',
        onEnter: () => { this._run3D = true; },
        onEnterBack: () => { this._run3D = true; },
        onLeave: () => { this._run3D = false; }
      });
    } else {
      this._shield = TweenMax.fromTo('.intro-content .shield', { opacity: 0, y: -90 }, { opacity: 0.8, y: 0, duration: 2 });
      this._timeline.add( this._shield, 1.5 );
      this._timeline.play();
    }

    ScrollTrigger.create({
      animation: this._scrollIndicator,
      trigger:'.intro-wrapper',
      start:'1% top'
    });

  }

  constructor () { }
}
